import { defineMessages } from 'react-intl'

export default defineMessages({
  preFieldLabel: {
    id: 'phonecountrycodefield.prefieldlabel',
    defaultMessage: 'Telephone number',
  },
  preFieldHelpText: {
    id: 'phonecountrycodefield.prefieldhelptext',
    defaultMessage: 'For international numbers please select the country code',
  },
  preFieldLabelV2: {
    id: 'phonecountrycodefield.prefieldlabelV2',
    defaultMessage: 'Phone number',
  },
  preFieldHelpTextV2: {
    id: 'phonecountrycodefield.prefieldhelptextV2',
    defaultMessage:
      'We’ll use it to call you about appointments or to discuss your health needs.',
  },
})
